<template>
    <div class="container-fluid">
          <div>
            <b-embed
               type="iframe"
               :src="('https://doc.goldpig88.com/' + language + '.php')"
               allowfullscreen
            ></b-embed>
            </div>
      </div>
</template>
<script>
export default {
    name:'ApiDocument',

    data() {
        return {
            language: undefined,
        }
    },

    async mounted() {
        let user = JSON.parse(localStorage.getItem("user"));

        if (user.language === 'en_US' || user.language === undefined) {
            this.language = 'en'  
        } 
        
        if (user.language === 'zh_CN') {
            this.language = 'cn'    
        } 
        
    },
}
</script>